const state = {
  auth:                    null,
  token:                   null,
  active:                  false,
  avatar:                  null,
  created_at:              null,
  deleted_at:              null,
  email:                   null,
  facebook:                null,
  first_name:              null,
  id:                      null,
  inn:                     null,
  instagram:               null,
  email_notifications:     false,
  last_name:               null,
  management_companies_id: null,
  name:                    null,
  passport:                null,
  second_name:             null,
  superadmin:              null,
  telephone:               null,
  type_user:               null,
  updated_at:              null,
  vk:                      null,
  account_number:          null,
  aparts:                  [],
  kvit:                    [],
  rash:                    [],
  devicesSettings:         [],
  device_types:            [],
  selectedDate:            null,
  selectedHouse:           null,
  houses:                  [],
  housesGroups:            null,
  apartmentsTypes:         [],
  payments:                [],
  paymentTypes:            [],
  permissions:             [],
};

export const initialState = { ...state };

export default state;
